"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

require("../style/index.css");

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/circleloader/index.css");

  require("../../spectrum-css/circleloader/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/circleloader/index-lg.css");
} else {
  require("../../spectrum-css/circleloader/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/circleloader/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/circleloader/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/circleloader/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/circleloader/multiStops/darkest.css");
var DETERMINATE = 'determinate';
var INDETERMINATE = 'indeterminate';

var Wait =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Wait, _React$Component);

  function Wait() {
    (0, _classCallCheck2["default"])(this, Wait);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Wait).apply(this, arguments));
  }

  (0, _createClass2["default"])(Wait, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? 0 : _this$props$value,
          _this$props$size = _this$props.size,
          size = _this$props$size === void 0 ? 'M' : _this$props$size,
          _this$props$indetermi = _this$props.indeterminate,
          indeterminate = _this$props$indetermi === void 0 ? true : _this$props$indetermi,
          _this$props$centered = _this$props.centered,
          centered = _this$props$centered === void 0 ? false : _this$props$centered,
          className = _this$props.className,
          variant = _this$props.variant,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["value", "size", "indeterminate", "centered", "className", "variant"]); // Determinate version has two high level masks, 1) right half, 2) left half
      // within each of those is a submask which rotates into view within that mask
      // but starts off on the opposite side so it's hidden
      // for first 50%, submask1 moves from -180 to 0 as it covers the first half
      // for the second 50%, submask1 stays in one place and submask2 rotates in
      // from -180 to 0

      var angle;
      var fillSubmask1Style = {};
      var fillSubmask2Style = {};
      var ariaValue = undefined;

      if (variant === DETERMINATE || variant === INDETERMINATE) {
        console.warn("The \"".concat(variant, "\" variant of Wait is deprecated. Please use the \"indeterminate\" prop instead."));
      }

      if (variant === DETERMINATE || !indeterminate) {
        value = Math.min(Math.max(+value, 0), 100);
        ariaValue = value;

        if (value > 0 && value <= 50) {
          angle = -180 + value / 50 * 180;
          fillSubmask1Style.transform = 'rotate(' + angle + 'deg)';
          fillSubmask2Style.transform = 'rotate(-180deg)';
        } else if (value > 50) {
          angle = -180 + (value - 50) / 50 * 180;
          fillSubmask1Style.transform = 'rotate(0deg)';
          fillSubmask2Style.transform = 'rotate(' + angle + 'deg)';
        }
      }

      return _react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _classnames["default"])('spectrum-CircleLoader', {
          'spectrum-CircleLoader--indeterminate': variant === INDETERMINATE || indeterminate && variant !== DETERMINATE,
          'spectrum-CircleLoader--small': size === 'S',
          'spectrum-CircleLoader--large': size === 'L',
          'spectrum-CircleLoader--overBackground': variant === 'overBackground',
          'react-spectrum-Wait--centered': centered
        }, className),
        role: "progressbar",
        "aria-valuenow": ariaValue,
        "aria-valuemin": 0,
        "aria-valuemax": 100
      }, (0, _filterDOMProps["default"])(otherProps)), _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-track"
      }), _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-fills"
      }, _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-fillMask1"
      }, _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-fillSubMask1",
        style: fillSubmask1Style
      }, _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-fill"
      }))), _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-fillMask2"
      }, _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-fillSubMask2",
        style: fillSubmask2Style
      }, _react["default"].createElement("div", {
        className: "spectrum-CircleLoader-fill"
      })))));
    }
  }]);
  return Wait;
}(_react["default"].Component);

exports["default"] = Wait;
(0, _defineProperty2["default"])(Wait, "propTypes", {
  /** Whether to center the Wait compnent in the parent container. */
  centered: _propTypes["default"].bool,

  /** Custom CSS class to add to the Wait component */
  className: _propTypes["default"].string,

  /**
   * Boolean to determine if the Wait component should endlessly spin (indeterminate) or
   * if it should be controlled manually.
   */
  indeterminate: _propTypes["default"].bool,

  /** Size of the Wait component */
  size: _propTypes["default"].string,

  /** Adjust the filled portion of the Wait component to a determined value */
  value: _propTypes["default"].number,

  /**
  * The variant of Wait to display.
  */
  variant: _propTypes["default"].oneOf(['overBackground'])
});